import { Model } from './abstract-model';
import Business from './business';
import Category from './category';
import { Product } from './product';

class Stock extends Model {
  business: Business;
  businessRef: any;
  key: string;
  product: Product;
  productRef: any;
  category: Category;
  categoryRef: any;
  price: number;
  quantity: number;
}

export default Stock;
